import { render, staticRenderFns } from "./OctChipSet.vue?vue&type=template&id=3bda68a6&scoped=true&"
import script from "./OctChipSet.vue?vue&type=script&lang=js&"
export * from "./OctChipSet.vue?vue&type=script&lang=js&"
import style0 from "./OctChipSet.vue?vue&type=style&index=0&id=3bda68a6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bda68a6",
  null
  
)

export default component.exports